<template>
  <div>
    <el-dialog :visible.sync="img_show" append-to-body>
      <el-image :src="img_src" style="width: 100%;"></el-image>
    </el-dialog>
    <el-row type="flex"
            style="text-align: center;margin-bottom: 2px;padding-bottom:2px ;border-bottom: 1px silver solid">
      <el-col :span="2">
        <el-tag size="small" effect="dark">题号</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag size="small" effect="dark">得分</el-tag>
      </el-col>
    </el-row>
    <el-row type="flex" v-for="(question,question_index) in question_group['questions']" :key="question_index"
            style="text-align: center;margin-bottom: 2px;padding-bottom:2px ;border-bottom: 1px silver solid">
      <el-col :span="2">
        <el-tag size="small" type="info" style="width: 45px">{{question.label}}</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag size="small" type="info" effect="dark" style="width: 45px">{{question.score}}</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag type="primary" size="small"
                @click="draw_marks($event,question.img_src,question.marks,question.describe)">查看卷面
        </el-tag>
      </el-col>
    </el-row>
    <canvas style="display: none" ref="canvas_bg">
    </canvas>
    <canvas style="display: none;background:rgba(255,255,255,0);"
            ref="canvas_mark">
    </canvas>
  </div>
</template>

<script>
  export default {
    name: "SubjectiveGroup",
    props: ["question_group"],
    data() {
      return {
        img_show: false,
        img_src: ""
      }
    },
    methods: {
      re_src(src) {
        src = src.indexOf('?') > -1 ? src : `${src}?${Math.floor(Math.random() * 90000000 + 1)}`
        return src
      },
      draw_marks(e, ref, marks, describe) {
        let src = `/chengjifabu/answer_img/${this.re_src(ref)}`
        let canvas_bg = this.$refs.canvas_bg
        let canvas_mark = this.$refs.canvas_mark
        let ctx_bg = canvas_bg.getContext('2d')
        let ctx_mark = canvas_mark.getContext('2d')
        let temp_img = new Image()
        temp_img.src = src
        temp_img.onload = () => {
          canvas_bg.width = canvas_mark.width = temp_img.width
          canvas_bg.height = canvas_mark.height = temp_img.height
          ctx_bg.drawImage(temp_img, 0, 0)
          marks = JSON.parse(JSON.stringify(marks))
          for (let mark of marks) {
            let mark_type = mark.mark_type
            let mark_info = mark.info
            if (mark_type === 'path') {
              ctx_mark.strokeStyle = "#ff0000"
              ctx_mark.beginPath()
              ctx_mark.moveTo(mark_info.shift(), mark_info.shift())
              while (mark_info.length > 0) {
                ctx_mark.lineTo(mark_info.shift(), mark_info.shift())
                ctx_mark.stroke()
              }
            } else if (mark_type === 'line') {
              ctx_mark.strokeStyle = "#ff0000"
              ctx_mark.beginPath()
              ctx_mark.moveTo(mark_info.shift(), mark_info.shift())
              ctx_mark.lineTo(mark_info.shift(), mark_info.shift())
              ctx_mark.stroke()
            } else if (mark_type === 'rect') {
              ctx_mark.strokeStyle = "#ff0000"
              ctx_mark.strokeRect(mark_info.shift(), mark_info.shift(), mark_info.shift(), mark_info.shift())
            } else if (mark_type === 'clear') {
              ctx_mark.strokeStyle = "#ff0000"
              ctx_mark.clearRect(mark_info.shift(), mark_info.shift(), mark_info.shift(), mark_info.shift())
            }
          }
          if (describe) {
            ctx_mark.fillStyle = "#ff0000";
            ctx_mark.font = "24px bold 黑体";
            ctx_mark.textAlign = "start";
            ctx_mark.textBaseline = "top";
            let line_width = 0
            let last_index = 0
            let init_height = 10
            for (let i = 0; i < describe.length; i++) {
              if (line_width > canvas_mark.width - 44) {
                ctx_mark.fillText(describe.substring(last_index, i), 10, init_height);//绘制截取部分
                init_height += 24;//20为字体的高度
                line_width = 0;
                last_index = i;
              }
              if (i === describe.length - 1) {//绘制剩余部分
                ctx_mark.fillText(describe.substring(last_index, i + 1), 10, init_height);
              }
              line_width += ctx_mark.measureText(describe[i]).width;
            }
          }
          ctx_bg.drawImage(canvas_mark, 0, 0)
          let url = canvas_bg.toDataURL()
          this.img_src = url
          this.img_show = true
          // canvas_bg.toBlob((blob) => {
          //   let url = URL.createObjectURL(blob)
          //   this.imgs = [url,]
          //   this.img_show = true
          // })
        }
      },
      check_answer(question) {
        let check_answers = question.check_answers
        let answers = question.answers
        if (check_answers.length !== answers.length) {
          return false
        } else {
          for (let _ in check_answers) {
            if (check_answers[_] !== answers[_]) {
              return false
            }
          }
        }
        return true
      },
      get_answer(a, b) {
        let out = ""
        for (let _ in a) {
          if (b[_]) {
            out = out + a[_]
          }
        }
        return out
      }
    }
  }
</script>

